import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=a0ed84b0&scoped=true"
import script from "./Nosotros.vue?vue&type=script&lang=js"
export * from "./Nosotros.vue?vue&type=script&lang=js"
import style0 from "./Nosotros.vue?vue&type=style&index=0&id=a0ed84b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ed84b0",
  null
  
)

export default component.exports